import { Tooltip } from "@mui/material";
import React, { useState } from "react";

import { ExportCircleIcon, EyeIcon } from "assets/icons";
import { useAppSelector } from "hooks/store";
import { GroundlightButton } from "new-components/buttons/GroundlightButton";
import { Typography } from "new-components/typography/Typography";
import { getUserState } from "store/slices/Auth/authSlice";
import { User } from "types/users";

import { ExportDataModal } from "./exportDataModal/ExportDataModal";

export interface ActionsMenuProps {
  handleClickOpenColumnsPanel: () => void;
  columnVisibilityModel: Record<string, boolean>;
  filtersObject: Record<string, string>;
  hideExportButton?: boolean;
}

export function ActionsMenu(props: ActionsMenuProps) {
  const { handleClickOpenColumnsPanel, columnVisibilityModel, filtersObject, hideExportButton = true } = props;

  const userInfo: User = useAppSelector(getUserState);

  const [openExportModal, setOpenExportModal] = useState<boolean>(false);

  const handleClickSelectExport = () => {
    setOpenExportModal(true);
  };

  const handleClickSelectColumns = () => {
    handleClickOpenColumnsPanel();
  };

  const enableExport = userInfo.enable_export_data;
  const isDetectorSelected = Boolean(filtersObject?.detector_id);
  const tooltipMessage = isDetectorSelected && !enableExport ? "Upgrade your plan to unlock this feature" : null;

  return (
    <>
      {!hideExportButton && (
        <Tooltip title={tooltipMessage}>
          <GroundlightButton
            variant="border"
            size="small"
            endIcon={ExportCircleIcon}
            onClick={handleClickSelectExport}
            disabled={!enableExport}
          >
            <Typography textTransform="uppercase" fontWeight="semibold">
              Export data
            </Typography>
          </GroundlightButton>
        </Tooltip>
      )}

      <Tooltip title={tooltipMessage}>
        <GroundlightButton
          variant="border"
          size="small"
          endIcon={EyeIcon}
          onClick={handleClickSelectColumns}
          disabled={!isDetectorSelected}
          data-testid="show-hide-columns-button"
        >
          <Typography textTransform="uppercase" fontWeight="semibold">
            Show/Hide Columns
          </Typography>
        </GroundlightButton>
      </Tooltip>

      {openExportModal && (
        <ExportDataModal
          open={openExportModal}
          onClose={() => setOpenExportModal(false)}
          columnVisibilityModel={columnVisibilityModel}
          filtersObject={filtersObject}
        />
      )}
    </>
  );
}
